// @ts-nocheck
/* eslint-disable */
import { store } from "~/state/store";
import SceneMarkerWindy from "./windy";

export default class SceneMarkerMapyWindy extends SceneMarkerWindy {
	/**
	 * Vytvoreni Windy markeru pro mapy.
	 *
	 * @param  {Object} poi Vstupni POI data
	 * @param  {Number|String} [id] Volitelne ID
	 * @param  {Object} [opts] Volitelny objekt s konfiguraci
	 */
	constructor(scene, itemId, coords?, id?, opts?) {
		super(scene, itemId, coords, id, opts);

		if (opts && "key" in opts) {
			this._id = `${this._id}-${opts.key}`;
		}

		this._source = this._poi ? this._poi.source : "";
		this._plainId = this._poi ? this._poi.source : "";
		this._title = "";
		this._popupData = null;
		this._fromData = null;
	}

	/**
	 * Informace ohledne entity ve scene.
	 *
	 * @return {Object}
	 */
	get featureInfo() {
		return {
			name: "SceneMarkerMapyWindy",
			type: "marker"
		};
	}

	/**
	 * Souhrn vsech dat, ktere vyuziva visualiser pri vytvoreni.
	 *
	 * @return {Object}
	 */
	getCreateData() {
		let rd = super.getCreateData();

		rd.source = this._source;
		rd.plainId = this._plainId;
		rd.title = this._title;
		rd.popupData = this._popupData;
		rd.fromData = this._fromData;

		return rd;
	}

	/**
	 * Naplneni dat markeru z POI dat.
	 *
	 * @param  {Object} poi POI data
	 * @param  {String|Number} id Vlastni id
	 * @param  {Object} opts Konfigurace
	 */
	fromPOI(poi, id, opts) {
		this._coords = this._scene.coordsFromWGS84(poi.mark.lon, poi.mark.lat);
		this._id = id || this._id;
		this._poi = poi;

		let typeId = "universal";

		if (poi.markerId) { typeId = poi.markerId; }

		let params = {
			type: this._scene.VISUAL.MARKER_WINDY[typeId.toUpperCase()] || {}
		};

		Object.assign(this._conf, Object.assign(params, opts));

		this._fromPOI = {
			poi: poi,
			id: id,
			opts: opts
		};
	}

	/**
	 * Naplneni markeru z POI dat.
	 *
	 * @param  {Object} data Vstupni data
	 */
	fromData(data) {
		let options = {
			type: this._scene.VISUAL.MARKER_WINDY[data.paid ? "PAID" : "POI"] || {}
		};

		this._coords = this._scene.coordsFromWGS84(data.mark.lon, data.mark.lat);
		this._title = "";
		this._source = data.source;
		this._plainId = data.id;
		this._popupData = data;
		this._poi = data;
		this._fromData = data;
		this._key = data.key;

		Object.assign(this._conf, options);
	}

	/**
	 * Nastaveni zdroje markeru.
	 *
	 * @param {String} source Novy zdroj
	 */
	setSource(source) {
		this._source = source;

		this._onChange(this._scene.featureEvent("markerPOISetSource", true, true), arguments);

		return this;
	}

	/**
	 * Nastaveni ID markeru.
	 *
	 * @param {Number} plainId Nove ID
	 */
	setPlainId(plainId) {
		this._plainId = plainId;

		this._onChange(this._scene.featureEvent("markerPOISetPlainId", true, true), arguments);

		return this;
	}

	/**
	 * Nastaveni popisku znacky.
	 *
	 * @param {String} title Popisek
	 */
	setTitle(title) {
		this._title = title;

		this._onChange(this._scene.featureEvent("markerMapyWMSetTitle", true, true), arguments);
	}

	/**
	 * Nastaveni karty podle POI dat.
	 *
	 * @param {Object} poi POI data
	 */
	setPopupFromPOI(poi) {
		this._popupData = poi;

		this._onChange(this._scene.featureEvent("markerPOISetPopupFromPOI", true, true), arguments);
	}

	/**
	 * Jedna se o detail? Marker reprezentuje zobrazi znacky v detailu.
	 *
	 * @return {Boolean}
	 */
	isDetail() {
		const { data } = store.getState().detail;

		if (!this._poi || !data) {
			return false;
		}

		return data.source === this._poi.source && data.id === this._poi.id;
	}

	/**
	 * Ziskani titulku znacky.
	 *
	 * @return {String}
	 */
	getTitle() {
		return this._title || this._options.title;
	}
}
